
import { DatasetSelectDropdown } from "../components/tradecalculator/DatasetSelectDropdown"
import {TeamCard} from "../components/tradecalculator/TeamCard"
import {useTeams, useTCData} from "../context"
import {BottomDisplay} from "../components/tradecalculator/BottomDisplay"
import {LoginButton} from "../components/common/LoginButton"
import {LogoutButton} from "../components/common/LogoutButton"
import {logo} from '../assets'
// import { useAuth0 } from "@auth0/auth0-react"; 
import {isNil, isEmpty} from 'ramda'

export const TradeCalculator = () => {
    const {team1, team2, setTeam1, setTeam2} = useTeams()
    const {tcData, tcDataError} = useTCData()
    // const { isAuthenticated } = useAuth0();
    const dataIsValid = (data) => {
        return !isNil(data) && !isEmpty(data)
    }
    return(
        <div>
            {/* <LogoutButton /> */}
            <div className="is-flex is-justify-content-center is-flex-direction-column is-align-items-center">
                <img src={logo} alt="Dynasty Dugout Logo" style={{objectFit: "cover", height: "25%", width:"auto", maxHeight: "200px"}} />
            </div>
            <div className="is-flex is-justify-content-center is-flex-direction-column is-align-items-center">
                <h1 style={{fontSize: "2.5rem", marginTop: "0", marginBottom: "1rem", fontWeight: "bold"}}>
                    Trade Calculator 
                </h1>
            </div>
            {/* {!isAuthenticated && <LoginButton />} */}
            {/* {isAuthenticated && dataIsValid(tcData) && ( */}
            {dataIsValid(tcData) && (
            <div>
                <div className="is-flex is-justify-content-center is-flex-direction-column is-align-items-center">
                    <p style={{fontSize: ".9rem"}}>Prospects who have not debuted or recently debuted have added value to better represent their overall dynasty value.</p>
                    <p style={{fontSize: ".9rem", marginBottom: "1rem"}}>This will not reflect in the average but in the total trade value. </p>
                </div>
                <center>
                    <div className="is-flex is-justify-content-center" style={{fontSize: ".8rem", margin: "0 7rem"}}>
                        <div>The <b>Roto Value</b> is based on three year projection system with aging curves incorporated. It is based for a standard 15-team Roto league that uses a mix between OBP and AVG and other traditional hitting stats. On the pitching side, a focus on IP and Quality Starts are used over wins while also factoring in saves and holds. Tradition pitching stats such as ERA, Ks and WHIP are included.
                            </div>
                        </div>
                        <div className="is-flex is-justify-content-center" style={{fontSize: ".8rem", margin: "0 7rem 2rem 7rem"}}>
                            <div>The <b>Points</b> scoring value looks at total points scored over a three-year window using aging curves and projections. It uses a balanced scoring system. For hitters: TB: 1.25, BB: 1, K: -.5, SB: 3, R: 1, RBI .5, IBB: 1, HBP: 1, GDIP: -.5, CS: -1.5. For Pitchers: Quality Appearance: 5, BB: -.5, K: 1.25, SV: 7, IP: 2, HLD: 4, H: -.5, ER: -1.25, BS: -3. In future updates we plan to have a custom scoring setting where you can input your league scoring settings.
                        </div>
                    </div>
                </center>
                <DatasetSelectDropdown />
                <div className="is-flex is-justify-content-space-evenly">
                    <TeamCard teamName={"Team 1"} setTeam={setTeam1} team={team1} />
                    <TeamCard teamName={"Team 2"} setTeam={setTeam2} team={team2} /> 
                </div>
                <BottomDisplay />
            </div>
            )}
            {/* {isAuthenticated && !tcDataError && !dataIsValid(tcData) && ( */}
            {!tcDataError && !dataIsValid(tcData) && (
                <div style={{margin: "3rem 5rem" }}>
                <progress className="progress is-danger" max="100"></progress>
                </div>
            )}
            {tcDataError && (
            // {isAuthenticated && tcDataError && (
                    <div className="is-flex is-justify-content-center">
                        Sorry, it looks like we're having trouble loading our data right now. Try again later!
                    </div>
            )}
        </div>
    )
}